<template>
  <div class="animated fadeIn orden-proveedor">
    <b-row>
      <b-col cols="12">
        <b-form>
          <b-card no-header>
            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="proveedor"
                :value= "proveedor" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Fecha Comp."
                  label-for="fechaComprobante"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="fechaComprobante" 
                    v-model= "fechaComprobante" 
                    type="date">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Importe Total"
                  label-for="importeTotal"
                  :label-cols="labelCols * 2"
                  horizontal
                  description="Precios IVA no incluido">
                  <b-form-input 
                    id="importeTotal"
                    :value="importeTotal | moneda(moneda)" 
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              label="Condiciones"
              label-for="formasPago"
              :label-cols="labelCols"
              horizontal>

              <div class="table-button" @click.prevent="agregarFormaPago">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :busy="tableBusy"
                  :items="formasPago" 
                  :fields="formasPagoFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>              
                <template v-slot:cell(porcentaje)="data">
                  {{ data.item.porcentaje | numero(2, true) }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="borrarFormaPago(data.item)">
                      <i class="fa fa-remove"></i>Eliminar</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-form-group>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Fecha Entrega"
                  label-for="fechaEntrega"
                  :label-cols="labelCols * 2"
                  description="Fecha de entrega pactada"
                  horizontal>
                  <b-form-input 
                    id="fechaEntrega" 
                    v-model="fechaEntrega" 
                    type="date">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              label="Dirección"
              label-for="direccionEntrega"
              :label-cols="labelCols"
              horizontal
              description="Dirección de entrega">
              <b-form-input 
                id="direccionEntrega"
                v-model.trim="$v.direccionEntrega.$model" 
                :state="direccionEntregaValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionEntregaFeedback">
                {{ direccionEntregaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="Observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model= "$v.observaciones.$model" 
                rows="3"
                max-rows="3"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="ordenSinCostos"
                  v-model="ordenSinCostos"
                  value= true
                  unchecked-value= false>
                  Emitida sin costos
              </b-form-checkbox>
            </b-form-group> -->

            <b-alert
              class="alert"
              :show="dismissCountDown"
              dismissible
              fade
              :variant="alertVariant"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged">
              <p>{{ alertMsj }}</p>
            </b-alert>             

            <div slot="footer" v-if="modal">
              <b-button size="sm" variant="primary" class="footer-button"
                @click.prevent="save">Grabar</b-button>
              <b-button size="sm" variant="danger" class="footer-button"
                @click.prevent="goBack">Cancelar</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="formaPagoModal" 
        title="Seleccionar Forma de Pago"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-forma-pago
        :noRequiereContrato="noRequiereContrato"
        :tieneContrato="tieneContrato"
        :contratoPagare="contratoPagare"
        @updateFormaPago="updateFormaPago"
        @closeFormaPago="closeFormaPago">
      </app-forma-pago>  
    </b-modal>

    <app-a-b-m-button
      v-if="!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import FormaPago from './FormaPago.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenproveedor/getField',
  mutationType: 'ordenproveedor/updateField',
});

export default {
  name: 'OrdenesProveedoresABM',
  props: {
    modal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    appABMButton: ABMButtons,
    appFormaPago: FormaPago,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      noValidar: true,
      direccionEntregaValida: null,
      direccionEntregaInvalidaMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      formasPagoFields: [
        { key: 'formaPago' },
        { 
          key: 'porcentaje',
          class: 'text-right'
        },
        { key: 'condiciones' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      labelCols: 2,
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'ordenProveedor',
      'fechaComprobante',
      'fechaEntrega',
      'proveedor',
      'moneda',
      'importeTotal',
      'formasPago',
      'direccionEntrega',
      'observaciones',
      'ordenSinCostos',

      'noRequiereContrato',
      'tieneContrato',
      'contratoPagare'
    ]),
  },  
  created() {
    if (!this.modal) {
      let ordenProveedorId = 0;
      if (this.$route.params){
        if (this.$route.params.id){
          ordenProveedorId = this.$route.params.id;
        }
      }

      if (ordenProveedorId != 0) {
        this.$store.dispatch('ordenproveedor/inicializar', ordenProveedorId)
          .catch(error => this.showErrorMsj(error));
      }
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "direccionEntrega" || validarTodos) {
        if (this.$v.direccionEntrega.$error) {
          this.direccionEntregaValida = false;
          if (!this.$v.direccionEntrega.maxLength) {
            this.direccionEntregaInvalidaMsj = 'La direccion de entrega sólo pueden contener hasta 150 caracteres';
          }
        } else {
          this.direccionEntregaValida = null;
          this.direccionEntregaInvalidaMsj = '';
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 2500 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = Boolean(true);

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      this.$v.$touch();

      // let formaPagoError = true;
      // if (this.formasPago) {
      //   if (this.formasPago.length != 0) {
      //     formaPagoError = false;
      //   }
      // }
      // if (formaPagoError) {
      //   save = Boolean(false);
      //   this.formaPagoValida = false;
      //   this.formaPagoInvalidaMsj = "Debe seleccionar al menos una forma de pago.";
      // }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('ordenproveedor/save')
            .then(() => {
              if (this.modal) {
                this.$emit('updateOrdenProveedor', 
                  this.$store.getters['ordenproveedor/ordenProveedor']);
              } else {          
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light')  
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'OrdenesProveedores' });
    },
    goBack() {
      if (this.modal) {
        this.$emit('closeOrdenProveedor');
      } else {
        this.$router.go(-1);
      }
    },
    agregarFormaPago() {
      this.$store.dispatch('ordenproveedorformapago/inicializar')
        .then(() => {
          this.$refs.formaPagoModal.show();
        })
    },
    borrarFormaPago(item) {
      this.showSpinner();
      this.$store.dispatch('ordenproveedor/removeFormaPago', item)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    updateFormaPago(ordenProveedorFormaPago) {
      this.$store.dispatch('ordenproveedor/addFormaPago', ordenProveedorFormaPago);
      this.$refs.formaPagoModal.hide();
    },
    closeFormaPago() {
      this.$refs.formaPagoModal.hide();
    }
  },
  watch: {
  },    
  validations: {
    direccionEntrega: {
      maxLength: maxLength(150)
    },
    observaciones: {
      maxLength: maxLength(2500)
    },
  },  
}
</script>

<style>
</style>
